import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createHead } from '@vueuse/head'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import wowPlugin from './plugins/wow'
import i18n from './i18n'
import '@/styles/base.scss'
import '@/components/static/css/common.css'
import '@/components/static/css/animate.css'
import '@/components/static/css/css_whir.css'
import '@/components/static/css/iconfont.css'
import '@/components/static/css/iconfontNew.css'
import '@/components/static/css/editor.css'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'; // 引入样式
import '@/styles/element-theme.scss'; // 覆盖 EP 主题色为企业蓝 #004f8e

const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate); // 使用持久化插件

app.use(i18n);
app.use(pinia);
app.use(router)
app.use(wowPlugin)
app.use(ElementPlus);
const head = createHead()
app.use(head)

app.mount('#app')


